import React from 'react';
import RealBrandLogo from '../../assets/img/real-brand-logo.svg';
import RezenBrandLogo from '../../assets/img/rezen-brand-logo.svg';
import useDeviceType from '../../hooks/useDeviceType';
import { AnalyticsEventEnum } from '../../types';
import { cn } from '../../utils/classUtils';
import AnalyticsEventOnLoad from '../Analytics/AnalyticsEventOnLoad';

interface AuthPageLayoutV2Props {
  children: React.ReactNode;
  eventName?: AnalyticsEventEnum;
  rightSection?: React.ReactNode;
  rightHeader?: React.ReactNode;
}

const AuthPageLayoutV2: React.FC<AuthPageLayoutV2Props> = ({
  children,
  eventName,
  rightSection,
  rightHeader,
}) => {
  const { isMobile } = useDeviceType();
  return (
    <div className='fixed top-0 right-0 bottom-0 left-0 w-full h-screen overflow-hidden bg-reskin-primary-navy'>
      <div className='flex justify-start md:justify-center items-center p-3 gap-4 h-16 relative'>
        <img src={isMobile ? RezenBrandLogo : RealBrandLogo} alt='real-logo' />
        {rightHeader && (
          <div className='absolute right-0 top-1/2 -translate-y-1/2 mr-3'>
            {rightHeader}
          </div>
        )}
      </div>
      <div className='flex flex-col lg:flex-row h-[calc(100vh-64px)]'>
        <div
          className={cn(
            'flex flex-col w-full h-full overflow-y-auto pb-24 lg:pb-0 mb-10 md:mb-0',
            rightSection && 'lg:w-1/2',
          )}
        >
          {children}
        </div>
        {rightSection && (
          <div className='w-1/2 lg:block hidden h-full relative'>
            {rightSection}
          </div>
        )}
        {eventName && <AnalyticsEventOnLoad eventName={eventName} />}
      </div>
    </div>
  );
};

export default AuthPageLayoutV2;
